import { auth } from '@monorepo/utils/firebase'
import { FirebaseAuthTypes, linkWithCredential } from '@monorepo/utils/firebase'

export const linkUser = async (credential: FirebaseAuthTypes.AuthCredential) => {
  const user = auth().currentUser
  if (user) {
    await linkWithCredential(user, credential)
    return
  }
}
